import React, { useState, useEffect } from 'react';
import signinimage from '../asserts/img/logodry.png';
import { toast } from 'react-toastify';
import Button from '../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';
import { IoMailOutline, IoLockClosedOutline, IoShieldCheckmarkOutline } from 'react-icons/io5';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, response, message } = useSelector((state) => state.user);

  useEffect(() => {
    if (response && response?.access_token) {
      if (rememberMe) {
        localStorage.setItem('userToken', response.access_token);
      } else {
        sessionStorage.setItem('userToken', response.access_token);
      }
      navigate('/dashboard');
    } else if (error) {
      toast(message || 'Something went wrong');
    }
  }, [response, error, navigate, message, rememberMe, dispatch]);

  const loginHandler = async (e) => {
    e.preventDefault();
    dispatch(signin({ username, password }));
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-left">
            <div className="login-left-content">
              <div className="login-logo-wrapper">
                <img src={signinimage} alt="TN Dry Fruits" className="login-logo" />
              </div>
              <h2 className="login-welcome">Welcome Back!</h2>
              <p className="login-subtitle">Sign in to your admin dashboard</p>
              <div className="login-features">
                <div className="login-feature">
                  <IoShieldCheckmarkOutline size={20} />
                  <span>Secure Admin Access</span>
                </div>
                <div className="login-feature">
                  <IoShieldCheckmarkOutline size={20} />
                  <span>Manage Products</span>
                </div>
                <div className="login-feature">
                  <IoShieldCheckmarkOutline size={20} />
                  <span>Track Orders</span>
                </div>
              </div>
            </div>
          </div>
          <div className="login-right">
            <div className="login-form-wrapper">
              <h3 className="login-form-title">Sign In</h3>
              <p className="login-form-subtitle">Enter your credentials to continue</p>
              <form onSubmit={loginHandler}>
                <div className="login-input-group">
                  <div className="login-input-icon">
                    <IoMailOutline size={18} />
                  </div>
                  <input
                    type="email"
                    className="login-input"
                    placeholder="Email Address"
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="login-input-group">
                  <div className="login-input-icon">
                    <IoLockClosedOutline size={18} />
                  </div>
                  <input
                    type="password"
                    className="login-input"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="login-options">
                  <label className="login-checkbox">
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={handleRememberMeChange}
                    />
                    <span className="login-checkmark"></span>
                    Remember Me
                  </label>
                </div>
                <Button
                  onclickfun={loginHandler}
                  disabled={loading}
                  className="login-submit"
                  text={loading ? 'Signing In...' : 'Sign In'}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
